import { useMutation, useQuery } from '@tanstack/react-query';
import { isBootstrapRateLimitError, tryBootstrap } from '../../auth/authBootstrap';
import type { User } from '../../auth/types';
import { QUERY_META } from '../core/queryMeta';
import { authKeys } from './authKeys';

export async function fetchAuthUser(force = false): Promise<User | null> {
  return tryBootstrap(force);
}

interface UseAuthBootstrapOptions {
  enabled: boolean;
  initialUser?: User | null;
}

export function useAuthBootstrapQuery({ enabled, initialUser = null }: UseAuthBootstrapOptions) {
  return useQuery({
    queryKey: authKeys.bootstrap(),
    queryFn: () => fetchAuthUser(false),
    enabled,
    retry: (failureCount, error) => isBootstrapRateLimitError(error) && failureCount < 2,
    retryDelay: (failureCount) => Math.min(3000, 750 * (failureCount + 1)),
    refetchOnWindowFocus: false,
    initialData: initialUser ?? undefined,
    meta: QUERY_META.sensitive,
  });
}

export function useRefreshAuthMutation() {
  return useMutation({
    mutationFn: (opts?: { force?: boolean }) => fetchAuthUser(Boolean(opts?.force)),
    meta: QUERY_META.sensitive,
  });
}

